import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { ButtonAction } from 'legacy/components/Button/ButtonAction'
import LoadingV2 from 'legacy/components/LoadingV2/LoadingV2'
import { screen } from 'legacy/styles/screen'

const LinkStyled = styled(Link)`
  display: none;
  margin-top: 30px;
  height: 21px;
  color: ${getToken('color-primary')};
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  cursor: pointer;
  text-decoration: underline;

  & > a {
    display: inline-block;
    text-decoration: underline;
  }

  ${screen.md} {
    display: block;
  }
`

const SignupBtn = styled(ButtonAction)`
  color: ${getToken('color-neutral-white')};
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  width: 100%;
  margin-bottom: 20px;
`

const FooterWrapper = styled.div`
  text-align: center;
  width: 100%;
`

const Text = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  color: ${getToken('color-neutral-white')};
  font-size: 13px;
`

function FormFooter({ isSubmitting, showLogin }) {
  return (
    <FooterWrapper>
      <SignupBtn square name="signupBtn" type="submit" disabled={isSubmitting} activated>
        {!isSubmitting && 'SIGN UP FOR FREE'}
        {isSubmitting && (
          <div>
            <LoadingV2 width="16px" height="16px" />
          </div>
        )}
      </SignupBtn>
      <Text>
        By clicking sign up, you agree that you have read and accepted our{' '}
        <Link
          href="https://loadsmart.com/master-saas-and-services-agreement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link href="https://loadsmart.com/user-agreement" target="_blank" rel="noopener noreferrer">
          User Agreement
        </Link>
      </Text>
      {showLogin && <LinkStyled to="login">Already have an account? Login here.</LinkStyled>}
    </FooterWrapper>
  )
}

FormFooter.defaultProps = {
  isSubmitting: undefined,
  showLogin: true,
}
FormFooter.propTypes = {
  isSubmitting: PropTypes.bool,
  showLogin: PropTypes.bool,
}

export default FormFooter
